import EmptyStatePattern from './EmptyStatePattern';
import DefaultEmptyState from './DefaultEmptyState';

export default DefaultEmptyState;
export { EmptyStatePattern };



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/EmptyState/index.js